import { validateMandatory } from './mandatory.js';
import { validateFormat } from './format.js';
import { validateDomain } from './domain.js';
import { validateMinMax, splitMulti, setMultiSeparator, getMultiSeparator } from './multiAnswer.js';

export function readFieldRules(field) {
  const v = field?.validation || {};
  // Dominis 'close-*' NO inline (close-api, close-external, close-conditional): les claus
  // vàlides les serveix un endpoint o una font externa (conjunt obert/gran) → NO es valida
  // contra cap llista al client, igual que al servidor. S'ignora el domini (el 'close' pla,
  // inline, SÍ que es valida).
  const domainType = v.domainType ?? field?.domainType ?? null;
  const isRefDomain = typeof domainType === 'string' && domainType.toLowerCase().startsWith('close-');
  return {
    mandatory: v.mandatory ?? field?.mandatory ?? null,
    format: v.format ?? field?.format ?? null,
    domain: isRefDomain ? null : (v.domain ?? field?.domain ?? field?.domainValue ?? null),
  };
}

export function validateValue(value, field) {
  const errors = [];
  if (!field) return { valid: true, errors };
  const rules = readFieldRules(field);

  const m = validateMandatory(value, rules.mandatory);
  if (!m.valid) errors.push({ field: field.id || field.name, ...m });

  if (rules.mandatory && (rules.mandatory.min != null || rules.mandatory.max != null || rules.mandatory.required)) {
    const mm = validateMinMax(value, rules.mandatory);
    if (!mm.valid) errors.push({ field: field.id || field.name, ...mm });
  }

  if (rules.mandatory?.max && rules.mandatory.max > 1) {
    const list = splitMulti(value, rules.mandatory?.separators);
    for (const piece of list) {
      const f = validateFormat(piece, rules.format);
      if (!f.valid) errors.push({ field: field.id || field.name, value: piece, ...f });
      const d = validateDomain(piece, rules.domain);
      if (!d.valid) errors.push({ field: field.id || field.name, value: piece, ...d });
    }
  } else {
    const f = validateFormat(value, rules.format);
    if (!f.valid) errors.push({ field: field.id || field.name, value, ...f });
    const d = validateDomain(value, rules.domain);
    if (!d.valid) errors.push({ field: field.id || field.name, value, ...d });
  }

  return { valid: errors.length === 0, errors };
}

export function validateRow(row, mappingByFieldId, fieldsById) {
  const errors = [];
  for (const [fieldId, field] of fieldsById) {
    const sourceColumn = mappingByFieldId.get(fieldId);
    const value = sourceColumn != null ? row[sourceColumn] : (field._defaultValue ?? null);
    const r = validateValue(value, field);
    if (!r.valid) errors.push(...r.errors);
  }
  return { valid: errors.length === 0, errors };
}

export { validateMandatory, validateFormat, validateDomain, validateMinMax, splitMulti, setMultiSeparator, getMultiSeparator };
